export default __webpack_public_path__ + "static/media/get_started_svg.8fca519d.svg";